// Loading state is signalled by body[aria-busy="true"] (CSS reveals .wait_mask);
// guard the lookup since not every page renders #js-body.
export function show() {
  document.getElementById('js-body')?.setAttribute('aria-busy', 'true');
}

export function hide() {
  document.getElementById('js-body')?.setAttribute('aria-busy', 'false');
}

// Expose the functions to the global scope for legacy scripts
// TODO remove this after migrating legacy scripts to modules
window.showLoadMask = show;
window.hideLoadMask = hide;
